import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { View } from "@instructure/ui-view";

import IasNavHeader from "../components/NavHeader/NavHeader";
import IasFormAddMinorLearner from "../components/FormAddMinorLearner/FormAddMinorLearner";
import IasProgressAlerts from "../components/ProgressAlerts/ProgressAlerts";
import useAccount from "../hooks/useAccount";
import pageStyles from "../components/PageWrapper/PageWrapper.module.scss";
import "../App.css";

const AddMinorLearner = () => {
    const { response: accountResponse, error } = useAccount();
    const [displayMinorLearners, setDisplayMinorLearners ] = useState(false);
    const [busy, setBusy] = useState(true);

    useEffect(() => {
        if (accountResponse) {
            setDisplayMinorLearners(accountResponse.displayMinorLearners);
            setBusy(false);
        } else {
            setBusy(true);
        }
    }, [accountResponse]);

    return (
        <div className="App">
            <View
                as="div"
                className={classnames(pageStyles.PageWrapper)}
                background={"primary"}
                padding="large"
            >
                <IasNavHeader title="Add Learners"/>
                <IasProgressAlerts/>
                {
                    !busy && displayMinorLearners && <IasFormAddMinorLearner />
                }

                {
                    (error || (!busy && !displayMinorLearners)) && <h2>You cannot add anonymous learners to this course.</h2>
                }
            </View>
        </div>
    );
};

export default AddMinorLearner;
